import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AnchoredPopupComponent } from '@shared/components/anchored-popup/anchored-popup.component';
import { KpiDetailPopupService } from '@shared/services/kpi-detail-popup/kpi-detail-popup.service';

import { KpiDetailCardComponent } from './kpi-detail-card.component';

/** Mounted once in the app shell, for every view that opens KPI detail cards. */
@Component({
  selector: 'app-kpi-detail-card-outlet',
  imports: [AnchoredPopupComponent, KpiDetailCardComponent, TranslatePipe],
  templateUrl: './kpi-detail-card-outlet.component.html',
  styles: ``
})
export class KpiDetailCardOutletComponent {
  protected readonly popupService = inject(KpiDetailPopupService);
  protected readonly state = this.popupService.state;
}
